import {Component} from 'react';
import h from 'react-hyperscript';
import {h2, p} from 'Components/Typography/Typography';
import content from 'Assets/data/globals.json';
import Button from 'Components/Buttons/Buttons';

class PermissionsError extends Component {
  render() {
    return (
      h('div', {
        className: 'error-message error-message--full',
      },
      h('div', null, [
        h(h2, {
          key: 'permissions-error',
          className: 'text--grey text--center permissions-error__title',
        }, content.errors.nonAdmin.title),
        h(p, {
          key: 'permissions-error-desc',
          className: 'text--grey text--center permissions-error__desc',
        }, content.errors.nonAdmin.desc),

        h(Button, {
          key: 'get-started',
          to: content.errors.nonAdmin.href,
          external: true,
          className: 'button--centered button--long margin-top--md',
          id: 'permissions-error__cta',
          type: 'basic',
        },
        content.errors.nonAdmin.link
        ),
      ])
      )
    );
  }
}

export default PermissionsError;
